module.exports = __webpack_public_path__ + "img/zuijia_06.6596ca1d.png";